import {envUtil} from '@px/helper/env';

export const LINKS = {
  PHEMEX_HOME: '/',
  TRADE: '/trade',
  TRADE_INVERSE: '/futures/inverse',
  TRADE_PILOT: '/futures/pilot',
  DEFAULT_TRADE: '/futures/BTC-USD',
  DEFAULT_TRADE_INVERSE: '/futures/inverse/BTC-USD',
  SPOT_TRADE: '/trade',

  TRADE_FUTURES: '/futures',

  PHEMEX_MARGIN_TRADE: '/margin/trade',
  PHEMEX_MEME_TRADE: '/meme/trade',
  REGISTER: '/register',
  LOGIN: '/login',
  PHEMEX_APP_DOWNLOAD: '/download',
  PHEMEX_ABOUT: '/about',
  PHEMEX_BONUS: '/bonus',
  PHEMEX_SECURITY: '/security',
  PHEMEX_FEES_CONDITIONS: '/fees-conditions',
  CRYPTO_TRADING_COMPETITION: '/crypto-trading-competition',
  ONE_CRYPTO_TRADING_COMPETITION: '/1-on-1-crypto-trading-competition',
  TRADING_DEPOSIT_BONUS: '/lp-trading-deposit-bonus',
  CRYPTO_CONVERTER: '/crypto-converter',
  CRYPTO_LAUNCHPAD: '/crypto-launchpad',

  ASSETS_OVERVIEW: '/assets/overview',
  ASSETS_OVERVIEW_ACCOUNT: '/assets/overview?tab=Account',
  ASSETS_SPOT_ACCOUNT: '/assets/spot-account',
  ASSETS_CONTRACT_ACCOUNT: '/assets/contract-account',
  ASSETS_PILOT_CONTRACT_ACCOUNT: '/assets/pilot-contract-account',
  ASSETS_INVESTMENT_ACCOUNT: '/assets/investment-account',
  ASSETS_FIAT_ACCOUNT: '/assets/fiat-account',
  ASSETS_MARGIN_ACCOUNT: '/assets/margin-account',
  ASSETS_TRADING_ACCOUNT: '/assets/trading-account',
  ASSETS_FUND_ACCOUNT: '/assets/fund-account',
  ASSETS_ORDER_HISTORY_GROUP: '/assets/order-history',
  ASSETS_DEPOSIT: '/assets/deposit',
  ASSETS_WITHDRAWAL: '/assets/withdrawal',
  ASSETS_WITHDRAWAL_ADDRESS: '/assets/withdrawal-address',
  ASSETS_FUNDS: '/assets/funds',
  ASSETS_SPOT_ORDER: '/assets/spot-order-history',
  ASSETS_SPOT_TRADE: '/assets/spot-trade-history',
  ASSETS_SPOT_PNL_DETAILS: '/assets/spot-pnl-history',
  ASSETS_CONVERSION_HISTORY: '/assets/conversion-history',
  ASSETS_PNL_DETAILS: '/assets/contract-pnl-details',
  ASSETS_ORDER_HISTORY: '/assets/contract-order-history',
  ASSETS_TRADE_HISTORY: '/assets/contract-trade-history',
  ASSETS_CONVERT_FAQ: '/assets/convert-faq',
  ASSETS_MARGIN_TRADE_ORDER_HISTORY: '/assets/margin-trade-order-history',
  ASSETS_MARGIN_TRADE_TRADE_HISTORY: '/assets/margin-trade-trade-history',
  ASSETS_MARGIN_TRADE_BORROW_HISTORY: '/assets/margin-trade-borrow-history',
  ASSETS_MARGIN_TRADE_REPAY_HISTORY: '/assets/margin-trade-repay-history',
  ASSETS_MARGIN_TRADE_INTEREST_HISTORY: '/assets/margin-trade-interest-history',
  ASSETS_PROOF_OF_RESERVES: '/proof-of-reserves',
  ASSETS_SPOT_HISTORY: '/assets/spot-history',
  ASSETS_MARGIN_HISTORY: '/assets/margin-history',
  ASSETS_CONTRACT_HISTORY: '/assets/contract-history',
  ASSETS_BUY_CRYPTO_HISTORY: '/assets/buy-crypto-history',
  ASSETS_DETAILS: '/assets/details',
  ASSETS_FIAT_DEPOSIT: '/assets/fiat-deposit',
  ASSETS_FIAT_WITHDRAW: '/assets/fiat-withdraw',
  ASSETS_BUY_SELL_CRYPTO_HISTORY: '/assets/fiat-buy-sell-crypto-history',
  ASSETS_LENDING_ACCOUNT: '/assets/lending-account',
  ASSETS_LENDING_HISTORY: '/assets/lending-history',
  ASSETS_DEPOSIT_WITHDRAW_HISTORY: '/assets/deposit-withdraw-history',
  ASSETS_TRANSFER_CONVERT_HISTORY: '/assets/transfer-convert-history',

  ACCOUNT_OVERVIEW: '/account/overview',
  ACCOUNT_VERIFICATION: '/account/verification',
  ACCOUNT_SECURITY: '/account/security',
  ACCOUNT_SUB_ACCOUNTS: '/account/sub-accounts',
  ACCOUNT_API_MANAGEMENT: '/account/api-management',
  ACCOUNT_PREMIUM_CENTER: '/account/points/my-privileges',
  SUB_ACCOUNT_HOME: '/account/sub-accounts',
  ACCOUNT_INVITE_FRIENDS: '/account/referral/invite-friends',
  VIP_PORTAL: '/vip-portal',
  SHARE_PREMIUM: '/account/referral/share-premium',
  ACCOUNT_SETTING: '/account/setting',
  ACCOUNT_TAX_REPORTING: '/account/tax-reporting',
  ACCOUNT_FEEDBACK: 'https://phemex.zendesk.com/hc/en-us/requests/new',

  CONTRACT: '/contract/perpetual-contract',
  CONTRACT_DATA_INSIGHT: '/contract/data-insight',
  CONTRACT_LEADERBOARD: '/contract/leaderboard',
  CONTRACT_INDEX_PRICE: '/contract/index-price',

  PHEMEX_REFERENCES: '/support',
  PHEMEX_BLOG: '/blogs',
  PHEMEX_STUDENT_FOUNDATION: '/student-foundation',
  PHEMEX_ANNOUNCEMENTS: '/announcements',
  PHEMEX_BRACKET_ORDERS: '90799',
  PHEMEX_RISK_LIMIT: '91102',
  PHEMEX_ADL: '91062',
  EARN_CRYPTO: '/earn-crypto',
  EARN_SAVINGS: '/earn-crypto/savings-account',
  EARN_LAUNCH_POOL: '/earn-crypto/launchpool',
  PREDICT_TO_EARN: '/crypto-prediction-market',
  COMPETITION: '/crypto-trading-competition',
  BUY_CRYPTO: '/buy-crypto',
  BUY_CRYPTO_PLACE_ORDER: '/buy-crypto/place-order',
  OTC_LEGEND_TRADING: '/otc/legend-trading',
  MARKETS: '/markets',
  PHEMEX_CONTRACT_TRADE: '/trade',
  PREMIUM: '/premium',
  BONUS: '/rewards-hub',
  ALL_STAR_PROGRAM: '/all-star-program',
  INSTITUTIONAL_CLIENT: '/institutional-clients',
  PHEMEX_ACADEMY: '/academy',
  CONTRACT_INTRODUCTION: '/contract/introduction',
  PHEMEX_PLATFORM: '/phemex-platform',
  ABOUT: '/about',
  FEES_CONDITIONS: '/fees-conditions',
  SECURITY: '/security',
  PHEMEX_CUSTOMER_SERVICE: 'https://phemex.zendesk.com/hc/en-us/requests/new',
  PHEMEX_API_DOC: 'https://github.com/phemex/phemex-api-docs',
  LEARN_CRYPTO: '/learn-crypto',
  PHEMEX_USER_GUIDES: '/user-guides',
  PHEMEX_HELP_CENTER: '/help-center',
  PHEMEX_GETTING_STARTED: '/getting-started',
  WHAT_IS_A_STOP_LOSS_ORDER: '90960',
  HOW_DO_MARKET_ORDERS_FILL: '90730',
  WHAT_IS_A_CLOSE_ON_TRIGGER_ORDER: '90921',
  HOW_DO_I_USE_HEDGE_MODE: '90652',
  WHAT_ARE_CONDITIONAL_ORDERS: '90968',
  HOW_DO_BUY_OR_SELL_A_COIN_SPOT_TRADING: '90861',
  HOW_DO_CHANGE_TRADING_PAIRS_SYMBOLS: '90821',
  PHEMEX_TESTNET: 'https://testnet.phemex.com',
  PHEMEX_ANNIVERSARY: 'https://anniversary.phemex.com',

  P2P_HOME: '/buy-crypto/fiat',
  P2P_HOME_LOGIN: '/buy-crypto/fiat/place-order',
  P2P_HOME_MARKET: '/buy-crypto/fiat/p2p-markets',
  COPY_TRADE: '/copy-trading/list',
  WEB3_PREMINING: '/web3/premining',
  WEB3_LENDING_MARKET: '/web3/lending',
  WEB3_LENDING_DETAILS: '/web3/lending/details-info',
  PREDICT_TO_EARN_DETAIL: '/crypto-prediction-market/detail',
  COPY_TRADE_LEADERBOARD: '/copy-trading/leaderboard',
  MY_REWARDS: '/bonus-center?tab=rewards',
  SPOT_MARGIN_DATA: '/spot/margin-data',
  CMS_CROSS_MARGIN_POSITION: '90752',
  CMS_MARGIN_GUIDE: '90627',
  CMS_MARK_PRICE: '91094',

  PHEMEX_WHATS_IS_THE_CRYPTO_CONVERTER: '90723',
  PHEMEX_HOW_DO_I_USE_THE_CRYPTO_CONVERTER: '90717',
  RECOMMEND_TO_TRADE_USDT: '/announcements/recommend-to-trade-usdt-margined-perpetual-contracts',

  FIAT_BUY_CRYPTO_PLACE_ORDER: '/fiat/buy-crypto/place-order',
  FIAT_DEPOSIT: '/fiat/deposit',
  BUY_CRYPTO_CARD_PLACE_ORDER: '/buy-crypto/card/place-order',
  BUY_CRYPTO_P2P_ORDERS: '/buy-crypto/fiat/orders',

  STRATEGY_DETAIL: '/bot-detail',
  STRATEGY_SQUARE: '/trading-bots',
  STRATEGY_SHARE: '/trading-bots/share',
  FUTURE_GRIDS_TRADING_CONTEST: '/trading-bots/futuregrids-contest',
  LEVERAGE_MARGIN: '/contract/leverage-margin',
  PHEMEX_CONTRACT_TRADE_USDS: '/trade/BTCUSDT',
  PROFIT_REINVESTMENT: '98031',

  // web3 menu list
  PHEMEXIA: '/web3/phemexia',
  WEB3_SOUL_PASS: '/web3/soulpass',
  WEB3_EQUITY_BENEFITS: '/web3/pt-benefits',
  WEB3_DUTCH_AUCTION: '/web3/pt-bidding',
  WEB3_STAKE: '/web3/stake/dashboard',
  WEB3_SOCIAL_TRADE_PT_REWARDS: '/web3/phemex-pulse/pt-rewards',
  WEB3_SOCIAL_TRADE_EXPLORE_GROUPS: '/web3/phemex-pulse/explore-groups',
  Web3_Whitepaper: 'https://phemex.gitbook.io/phemex-web3-whitepaper/',

  // tr
  PHEMEX_TR: 'https://phemex.com.tr/',
  MOCK_TRADE: '/moc/trade/ETH-MUSDT',
};

const CMS_WHITE_LIST = [
  '/support',
  '/blogs',
  '/announcements',
  '/help-center',
  '/help-center/what-is-a-bracket-order',
  '/help-center/risk-limit',
  '/help-center/what-is-the-insurance-fund-and-auto-deleveraging',
  '/help-center/what-is-a-stop-loss-order',
  '/help-center/how-do-market-orders-fill',
  '/help-center/what-is-a-close-on-trigger-order',
  '/help-center/what-are-conditional-orders',
  '/help-center/how-do-i-buy-or-sell-a-coin-spot-trading',
  '/help-center/how-do-i-change-trading-pairs-symbols',
  '/help-center/mark-price-and-dual-price-mechanism',
  '/announcements/recommend-to-trade-usdt-margined-perpetual-contracts',
  '/help-center/what-is-profit-reinvestment',
];

/**
 * 修正测试网 references 地址
 * TODO: 移除
 * @param LINKS
 */
function fixReferences(LINKS) {
  if (!envUtil.isTestNet) {
    return;
  }

  Object.keys(LINKS).forEach((name) => {
    const link = LINKS[name];
    if (CMS_WHITE_LIST.indexOf(link) > -1) {
      LINKS[name] = window.location.origin.replace('testnet.', '') + link;
    }
  });
}
